// extracted by mini-css-extract-plugin
export var button = "_cb-0";
export var icon = "_cb-1";